import type { ArticleSuggestion } from "@repo/app-types/entities/liveCoaching";
import { IconBook2 } from "@tabler/icons-react";
import type { FC } from "react";
import { GridList, GridListItem } from "react-aria-components";
import { tv } from "tailwind-variants";

export interface ArticleSuggestionsWidgetProps {
  articleSuggestions: readonly ArticleSuggestion[];
  onAction: (suggestion: ArticleSuggestion) => void;
}

const articleCard = tv({
  slots: {
    card: "border-slate-150 flex min-w-[120px] flex-1 cursor-pointer items-start gap-2 rounded-lg border bg-slate-50 px-2.5 py-2 text-left transition-colors hover:border-border-strong hover:bg-slate-100",
    icon: "mt-0.5 size-3.5 shrink-0 text-slate-400",
    body: "min-w-0 flex-1",
    title: "truncate text-[11px] font-semibold text-slate-600",
    summary: "truncate text-[10px] text-slate-400",
  },
});

export const ArticleSuggestionsWidget: FC<ArticleSuggestionsWidgetProps> = (
  props,
) => {
  const styles = articleCard();
  return (
    <GridList
      aria-label="Suggested articles"
      className="flex gap-2 overflow-x-auto"
      items={props.articleSuggestions}
      selectionMode="none"
    >
      {(suggestion) => (
        <GridListItem
          onAction={() => props.onAction(suggestion)}
          className={styles.card()}
        >
          <IconBook2 className={styles.icon()} />
          <div className={styles.body()}>
            <p className={styles.title()}>{suggestion.title}</p>
            <p className={styles.summary()}>{suggestion.summary}</p>
          </div>
        </GridListItem>
      )}
    </GridList>
  );
};
